import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatToTwoDecimal } from "../../../../../utils/numberFormatter";
import PdfExportHeader from "../../../../../components/Export/PdfExportHeader";

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 60,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "transparent",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#403E92",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
    backgroundColor: "#403E92",
    color: "white",
  },
  tableCol: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
  },
  tableCell: {
    fontSize: 8,
  },
  noData: {
    fontSize: 12,
    textAlign: "center",
    paddingVertical: 12,
  },
  footer: {
    position: "absolute",
    bottom: -20,
    left: 0,
    right: 0,
    textAlign: "right",
    fontSize: 8,
  },
});

export const EXPENSE_COLUMNS = [
  "Transaction ID",
  "Expenses Type",
  "Foreign Type",
  "Amount",
  "Description",
  "Date Approved",
  "Expenses Date",
  "Status",
];

// Shared with expensesExcel.js so both files show the same values
export function getExpenseType(row) {
  if (!row.expenses2) return "NA";
  const typeOne = row.expenses2.expenses_one?.expenses_type_one;
  return typeOne
    ? `${row.expenses2.sub_type} (${typeOne})`
    : row.expenses2.sub_type || "NA";
}

export function getExpenseCells(row) {
  return [
    row.client_transaction_id || "",
    getExpenseType(row),
    row.foreign || "NA",
    `${row.currency_name || ""} ${formatToTwoDecimal(row.totalAmount)}`.trim(),
    row.desc || "NA",
    row.date_approved
      ? new Date(row.date_approved).toLocaleString("en-US")
      : "n/a",
    row.expenses_date
      ? new Date(row.expenses_date).toLocaleDateString("en-US")
      : "n/a",
    row.status || "",
  ];
}

// `records` are already-loaded expenses (see expensesExportConfig) and `meta`
// comes from buildExportMeta. This file must not fetch, since it is rendered
// inside expensesPdf.worker.jsx.
const ExpensesPdf = ({ records = [], meta }) => (
  <Document title={meta.fileName}>
    <Page size="A4" style={styles.page} orientation="landscape">
      <PdfExportHeader meta={meta} />

      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          {EXPENSE_COLUMNS.map((label) => (
            <View key={label} style={styles.tableColHeader}>
              <Text style={styles.tableCell}>{label}</Text>
            </View>
          ))}
        </View>
        {records.length > 0 ? (
          records.map((row, idx) => (
            <View key={row.id || idx} style={styles.tableRow} wrap={false}>
              {getExpenseCells(row).map((value, i) => (
                <View key={i} style={styles.tableCol}>
                  <Text style={styles.tableCell}>{value}</Text>
                </View>
              ))}
            </View>
          ))
        ) : (
          <Text style={styles.noData}>No data</Text>
        )}
      </View>

      <View fixed>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </View>
    </Page>
  </Document>
);

export default ExpensesPdf;
